var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-indigo-600 h-screen"
  }, [_c('div', {
    staticClass: "flex flex-col items-center justify-center pt-1/20 space-y-10 text-indigo-300"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  }), _vm._v(" "), _vm.infos.reason === 'revoque' ? _c('div', [_c('h5', [_vm._v("\n        " + _vm._s(_vm.infos.host.firstname) + " " + _vm._s(_vm.infos.host.lastname) + " a révoqué vos\n        droits, vous n'avez plus accès à son Neopass.\n      ")])]) : _vm._e(), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center mt-15"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Retour à l'écran de connexion",
      "uppercase": true,
      "icon": "log-out"
    }
  })], 1)], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h5', [_vm._v("Pour vous connecter avec des identifiants, ou vous inscrire,")]), _vm._v(" "), _c('h5', [_vm._v("vous pouvez vous diriger vers l'écran de connexion")])]);

}]

export { render, staticRenderFns }